<div class="sbi-toast-container">
  @for (toast of toasts(); track toast.id) {
    <sbi-toast-item [toast]="toast" (dismissed)="onDismissed($event)" />
  }
</div>